import request from "../../untils/request.js"


export const getPatientsAwaitingPayment = (params) => {
    return request.get('/outpatient/api/v2/outpatient/charges/pending-patients',{params})
}

export const getPatientsAwaitingPaymentByPatientId = (params) => {
    return request.get('/outpatient/api/v2/outpatient/charges/pending-orders',{params})
}

export const fullOrderCharge = (data) => {
    return request.post('/outpatient/api/v2/outpatient/charges',data)
}

export const getChargesQuery = (params) => {
    return request.get('/outpatient/api/v2/outpatient/charges',{params})
}

export const chargesRefunds = (data) => {
    return request.post('/outpatient/api/v2/outpatient/refunds',data)
}


export const getChargesByChargeId = (chargeId) => {
    return request.get(`/outpatient/api/v2/outpatient/charges/${chargeId}`)
}

//查询待执行患者
export const getExecutionPlansPatients = (params) => {
    return request.get('/outpatient/api/v2/outpatient/execution-plans/pending-patients',{params})
}
//查询患者执行计划
export const getExecutionPlans = (params) => {
    return request.get('/outpatient/api/v2/outpatient/execution-plans',{params})
}
//执行护理计划
export const executionPlansByPlanId = (planId,data) => {
    return request.post(`/outpatient/api/v2/outpatient/execution-plans/${planId}/execute`,data)
}
//查询执行计划记录
export const getExecutionPlansRecords = (planId) => {
    return request.get(`/outpatient/api/v2/outpatient/execution-plans/${planId}/records`)
}


export const getOrderDetailById = (orderId) => {
    return request.get(`/outpatient/api/v2/outpatient/orders/${orderId}`)
}

export const getExecutionPlansPage = (params) => {
    return request.get(`/outpatient/api/v2/outpatient/execution-plans/page`,{params})
}

export const executionPlans = (data) => {
    return request.post(`/outpatient/api/v2/outpatient/execution-plans/execute`,data)
}

export const getRefundableCharges = (params) => {
    return request.get(`/outpatient/api/v2/outpatient/refunds/refundable-charges`,{params})
}

export const cancelOrderById = (orderId,params) => {
    return request.post(`/outpatient/api/v2/outpatient/orders/${orderId}/cancel`,{params})
}

export const editOrderById = (orderId,params) => {
    return request.put(`/outpatient/api/v2/outpatient/orders/${orderId}`,{params})
}

export const getReturnDrugDetail = (params) => {
    return request.get(`/outpatient/api/v2/outpatient/refunds/refundable-item`,{params})
}

export const submitReturnDrugDetail = (data) => {
    return request.post(`/outpatient/api/v2/outpatient/refunds/refundable-return`,data)
}

export const submitReturnDrugDetailAll = (params) => {
    return request.get(`/outpatient/api/v2/outpatient/refunds/refundable-returnAll`,{params})
}

export const getOrdersByPatientId = (params) => {
    return request.get(`/outpatient/api/v2/outpatient/orders`,{params})
}
export const submitReturnDrugDetailTcm = (data) => {
    return request.post(`/outpatient/api/v2/outpatient/refunds/refundable-returnTcm`,data)
}

export default{

}